export default "__VITE_ASSET__$cPBXPB3__"